"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importStar(require("styled-components"));

var Base_1 = __importDefault(require("./Base"));

var darkModeStyles = function darkModeStyles(p) {
  return p.mode === 'dark' ? styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        border-color: ", ";\n        color: ", ";\n        &:hover {\n          background: ", ";\n          border-color: ", ";\n          color: ", ";\n        }\n\n        &:focus {\n          ", ";\n        }\n\n        &:focus-visible {\n          ", ";\n        }\n      "], ["\n        border-color: ", ";\n        color: ", ";\n        &:hover {\n          background: ", ";\n          border-color: ", ";\n          color: ", ";\n        }\n\n        &:focus {\n          ", ";\n        }\n\n        &:focus-visible {\n          ", ";\n        }\n      "])), p.theme.color.neutral.v100, p.theme.color.neutral.v100, p.theme.color.neutral.v100, p.theme.color.neutral.v100, p.theme.color.neutral.v500, p.theme.form.focus.dark, p.theme.form.focus.dark) : '';
};

var specialModeStyles = function specialModeStyles(p) {
  return p.mode === 'special' ? styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        background: transparent;\n        border-color: ", ";\n        color: ", ";\n        &:hover {\n          background: ", ";\n          border-color: ", ";\n          color: ", ";\n        }\n      "], ["\n        background: transparent;\n        border-color: ", ";\n        color: ", ";\n        &:hover {\n          background: ", ";\n          border-color: ", ";\n          color: ", ";\n        }\n      "])), p.theme.color.secondary.v200, p.theme.color.secondary.v200, p.theme.color.secondary.v300, p.theme.color.secondary.v300, p.theme.color.neutral.v100) : '';
};

exports.default = styled_components_1.default(Base_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background: transparent;\n  border-color: ", ";\n  color: ", ";\n\n  &:hover {\n    background: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n\n  ", "\n  ", "\n"], ["\n  background: transparent;\n  border-color: ", ";\n  color: ", ";\n\n  &:hover {\n    background: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n\n  ", "\n  ", "\n"])), function (p) {
  return p.theme.color.primary.v200;
}, function (p) {
  return p.theme.color.primary.v200;
}, function (p) {
  return p.theme.color.primary.v300;
}, function (p) {
  return p.theme.color.primary.v300;
}, function (p) {
  return p.theme.color.neutral.v100;
}, darkModeStyles, specialModeStyles);
var templateObject_1, templateObject_2, templateObject_3;